export default __webpack_public_path__ + "static/Lisboa2020_RGB_1b-07aa1df850bbde72f6b06612e86289bf.png";